// extracted by mini-css-extract-plugin
module.exports = {"base":"Flex_base__Bizky"};